import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import {
  CalendarCheck,
  LayoutDashboard,
  Filter,
  Timer,
  ThumbsUp,
  Banknote,
  Building2,
  Handshake,
  Globe,
} from "lucide-react";


const TABS = [
  { to: "/reports/overview", label: "Overview", icon: LayoutDashboard },
  { to: "/reports/funnel", label: "Funnel", icon: Filter },
  { to: "/reports/velocity", label: "Velocity", icon: Timer },
  { to: "/reports/win-loss", label: "Win/Loss", icon: ThumbsUp },
  { to: "/reports/collections", label: "Collections", icon: Banknote },
  { to: "/reports/inventory", label: "Inventory", icon: Building2 },
  { to: "/reports/website-enquiries", label: "Website", icon: Globe },
  { to: "/reports/channel-partners", label: "Channel Partners", icon: Handshake },
  { to: "/reports/attendance", label: "Attendance", icon: CalendarCheck },
];

function TabLink({ to, label, icon: Icon, isActive }) {
  return (
    <Link
      to={to}
      className={`flex items-center gap-2 px-1 py-3 text-[14px] font-medium border-b-2 transition-colors ${
        isActive
          ? "border-slate-900 text-slate-900"
          : "border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300"
      }`}
    >
      <Icon className="h-4 w-4" />
      {label}
    </Link>
  );
}

export default function ReportsLayout() {
  const location = useLocation();

  return (
    <>
      <div className="flex h-full flex-col bg-white">
        {/* Header */}
        <div className="px-8 pt-8">
          <h1 className="mb-6 text-[28px] font-bold tracking-tight text-slate-900">Reports</h1>

          {/* Tabs */}
          <nav className="flex items-center gap-6 overflow-x-auto border-b border-slate-200">
            {TABS.map((tab) => (
              <TabLink
                key={tab.to}
                to={tab.to}
                label={tab.label}
                icon={tab.icon}
                isActive={location.pathname === tab.to}
              />
            ))}
          </nav>
        </div>

        {/* Content */}
        <main className="flex-1 overflow-auto px-8 py-7">
          <Outlet />
        </main>
      </div>
    </>
  );
}
